// @flow
// @jsx h
import { h, Component } from "preact";
import styles from "./FormInput.scss";
import InputError from "./InputError";
import PhoneInput from "./PhoneInput";
import SwitchInput from "./SwitchInput";
import AutocompleteAddress from "./AutocompleteAddress";
import { Text } from "preact-i18n";

declare var GOOGLE_MAP_URL: string;

type FormInputProps = {
  clientFormField: ClientFormField,
  handleInputChange: Function,
  error: boolean,
  locale: string,
  isClientInformationMandatory?: boolean,
  value: string,
  emailconfirmvalue: string,
  emailConfirm?:boolean
};

export default class FormInput extends Component<FormInputProps> {
  constructor(props: FormInputProps) {
    super(props);
  }

  componentDidMount() {
    if (
      this.props.clientFormField._embedded.clientFormInputType.inputType === "TEL" &&
      this.props.value !== undefined
    ) {
      this.props.handleInputChange({
        value: this.props.value,
        clientFormInputType: {
          id: this.props.clientFormField._embedded.clientFormInputType.id,
          code: this.props.clientFormField._embedded.clientFormInputType.code,
          type: this.props.clientFormField._embedded.clientFormInputType.type,
          inputType:
            this.props.clientFormField._embedded.clientFormInputType.inputType
        },
        isValid: true
      });
    }
    if (
      this.props.clientFormField._embedded.clientFormInputType.inputType ===
        "SELECT" &&
      this.props.value === undefined
    ) {
      // Always set a default value for select inputs
      let defaultValue =
        this.props.clientFormField._embedded.clientFormInputType._embedded.options[
          Object.keys(
            this.props.clientFormField._embedded.clientFormInputType._embedded
              .options
          )[0]
        ];
      this.props.handleInputChange({
        value: defaultValue,
        clientFormInputType: {
          id: this.props.clientFormField._embedded.clientFormInputType.id,
          code: this.props.clientFormField._embedded.clientFormInputType.code,
          type: this.props.clientFormField._embedded.clientFormInputType.type,
          inputType: this.props.clientFormField._embedded.clientFormInputType.inputType
        },
        isValid: true
      });
    }
  }

componentDidUpdate(prevProps) {
  const { clientFormField, value, emailconfirmvalue } = this.props;

  const isEmailField = clientFormField._embedded.clientFormInputType.inputType === "EMAIL";

  // Vérifie si les props viennent d’être mises à jour
  if (
    isEmailField &&
    value !== undefined &&
    emailconfirmvalue !== undefined &&
    (prevProps.emailconfirmvalue !== emailconfirmvalue || prevProps.value !== value)
  ) {
    this.props.handleInputChange({
      value: emailconfirmvalue, // ou value selon le champ
      clientFormInputType: {
        code: "emailconfirm",
        inputType: "EMAILCONFIRM",
        id: -9999
      }
    });
  }
}


  onInputBlur = ({ target }: SyntheticInputEvent<HTMLInputElement>) => {
  if (this.props.handleInputOnBlur) {
    this.props.handleInputOnBlur({
      value : target.value,
      clientFormInputType: {
        id: this.props.clientFormField._embedded.clientFormInputType.id,
        code: this.props.clientFormField._embedded.clientFormInputType.code,
        type: this.props.clientFormField._embedded.clientFormInputType.type,
        inputType: this.props.clientFormField._embedded.clientFormInputType.inputType
      },
      isValid: target.isValid
    });
  }

  };

  onInputChange = ({ target }: SyntheticInputEvent<HTMLInputElement>) => {
    const value: boolean | string =
      target.type === "checkbox" ? (target.checked ? "1" : "0") : target.value;

    this.props.handleInputChange({
      value,
      clientFormInputType: {
        id: this.props.clientFormField._embedded.clientFormInputType.id,
        code: this.props.clientFormField._embedded.clientFormInputType.code,
        type: this.props.clientFormField._embedded.clientFormInputType.type,
        inputType: this.props.clientFormField._embedded.clientFormInputType.inputType
      },
      isValid: target.isValid
    });
  };

  onInputConfirmChange = ({
    target
  }: SyntheticInputEvent<HTMLInputElement>) => {
    const value: string = target.value;
    
    this.props.handleInputChange({
      value,
      clientFormInputType: {
        code: "emailconfirm",
        inputType: "EMAILCONFIRM",
        id: -9999 // ou l’id négatif que tu as généré
      }
    });
  };

  onInputConfirmBlur = ({
    target
  }: SyntheticInputEvent<HTMLInputElement>) => {
    const value: string = target.value;
    if (this.props.handleInputOnBlur) {
      this.props.handleInputOnBlur({
        value,
        clientFormInputType: {
          inputType: "EMAILCONFIRM"
        }
      });
    }
  };

  onAddressChange = (address: GoogleAddress) => {
    const value = JSON.stringify(address);
    this.props.handleInputChange({
      value,
      clientFormInputType: {
        id: this.props.clientFormField._embedded.clientFormInputType.id,
        code: this.props.clientFormField._embedded.clientFormInputType.code,
        type: this.props.clientFormField._embedded.clientFormInputType.type,
        inputType: this.props.clientFormField._embedded.clientFormInputType.inputType
      }
    });
  };

  onAddressBlur = (address: GoogleAddress) => {
    if (this.props.handleInputOnBlur) {
      const value = JSON.stringify(address);
      this.props.handleInputOnBlur({
      value,
      clientFormInputType: {
        id: this.props.clientFormField._embedded.clientFormInputType.id,
        code: this.props.clientFormField._embedded.clientFormInputType.code,
        type: this.props.clientFormField._embedded.clientFormInputType.type,
        inputType: this.props.clientFormField._embedded.clientFormInputType.inputType
      }
    });
    }
  }

  render({
    theme,
    clientFormField,
    value,
    error,
    locale,
    isClientInformationMandatory,
    emailconfirmvalue,
    emailConfirm
  }: {
    clientFormField: ClientFormField,
    value?: string | boolean,
    error?: {
      id: number,
      type: "mandatory" | "invalid"
    },
    locale?: string,
    isClientInformationMandatory?: boolean,
    emailconfirmvalue?:string,
    emailConfirm?:boolean
  }) {
    if (clientFormField._embedded.clientFormInputType.inputType === "TEL") {
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <label
            htmlFor={clientFormField.id}
            class={theme && theme.label ? theme.label : styles.label}
          >
            {clientFormField._embedded.clientFormInputType.label}
            {clientFormField.mandatory && (
              <span
                class={
                  theme && theme.requiredSign
                    ? theme.requiredSign
                    : styles.requiredSign
                }
              >
                *
              </span>
            )}
            {!clientFormField.mandatory && (
              <span>
                {" "}
                (<Text id="clientForm.facultatif">facultatif</Text>)
              </span>
            )}
          </label>
          <PhoneInput
            name={clientFormField._embedded.clientFormInputType.label}
            id={clientFormField.id}
            value={value}
            placeholder={clientFormField._embedded.clientFormInputType.label}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            locale={locale}
          />
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "EMAIL"
    ) {
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <label
            htmlFor={clientFormField.id}
            class={theme && theme.label ? theme.label : styles.label}
          >
            {clientFormField._embedded.clientFormInputType.label}
            {clientFormField.mandatory && (
              <span
                class={
                  theme && theme.requiredSign
                    ? theme.requiredSign
                    : styles.requiredSign
                }
              >
                *
              </span>
            )}
            {!clientFormField.mandatory && (
              <span>
                {" "}
                (<Text id="clientForm.facultatif">facultatif</Text>)
              </span>
            )}
          </label>
          <input
            name={clientFormField._embedded.clientFormInputType.label}
            id={clientFormField.id}
            type="email"
            value={value}
            placeholder={clientFormField._embedded.clientFormInputType.label}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            class={styles.input}
            maxLength={255} 
          />          
          {(emailConfirm == true || emailConfirm == undefined ) && (
            <div
            class={
              theme && theme.inputField ? theme.inputField : styles.inputField
            }
          >
            <label
              htmlFor={clientFormField.id + "confirm"}
              class={theme && theme.label ? theme.label : styles.label}
              style="margin-top:8px;"
            >
              <Text id="clientForm.emailconfirm">Confirmation email</Text>
              {clientFormField.mandatory && (
                <span class="requiredSign__2J5yT">*</span>
              )}
              {!clientFormField.mandatory && (
                <span>
                  {" "}
                  (<Text id="clientForm.facultatif">facultatif</Text>)
                </span>
              )}
            </label>
            <input
              name={
                clientFormField._embedded.clientFormInputType.label + "confirm"
              }
              id={clientFormField.id + "confirm"}
              type="email"
              onChange={this.onInputConfirmChange}
              onBlur={this.onInputConfirmBlur}
              autocomplete="off"
              defaultValue=""
              value={emailconfirmvalue}
              onPaste={e => {
                e.preventDefault();
              }}
              class={styles.input}
              maxLength={255} 
            />
          </div>
          )}
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "TEXT"
    ) {
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <label
            htmlFor={clientFormField.id}
            class={theme && theme.label ? theme.label : styles.label}
          >
            {clientFormField._embedded.clientFormInputType.label}
            {clientFormField.mandatory && (
              <span
                class={
                  theme && theme.requiredSign
                    ? theme.requiredSign
                    : styles.requiredSign
                }
              >
                *
              </span>
            )}
          </label>
          <input
            name={clientFormField._embedded.clientFormInputType.label}
            id={clientFormField.id}
            type="text"
            value={value}
            placeholder={clientFormField._embedded.clientFormInputType.label}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            class={styles.input}
            maxLength={255} 
          />
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "SELECT"
    ) {
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <label class={theme && theme.label ? theme.label : styles.label}>
            {clientFormField._embedded.clientFormInputType.label}
            {clientFormField.mandatory && (
              <span
                class={
                  theme && theme.requiredSign
                    ? theme.requiredSign
                    : styles.requiredSign
                }
              >
                *
              </span>
            )}
          </label>
          <div
            class={
              theme && theme.selectWrapper
                ? theme.selectWrapper
                : styles.selectWrapper
            }
          >
            <select
              name={clientFormField._embedded.clientFormInputType.label}
              value={value}
              onChange={this.onInputChange}
              class={styles.select}
            >
              {Object.entries(
                clientFormField._embedded.clientFormInputType._embedded.options
              ).map(entry => (
                <option key={entry[1]} value={entry[1]}>
                  {entry[0]}
                </option>
              ))}
            </select>
          </div>
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "CHECKBOX"
    ) {
      const uniqueId = `${clientFormField.id}-${Math.random().toString(36).substr(2, 9)}`;
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <div
            class={
              theme && theme.switchInput
                ? theme.switchInput
                : styles.switchInput
            }
          >
            <SwitchInput
              name={clientFormField._embedded.clientFormInputType.label}
              id={uniqueId}
              value={value}
              onChange={this.onInputChange}
            />
            <label
              class={theme && theme.label ? theme.label : styles.label}
              htmlFor={uniqueId}
            >
              {clientFormField._embedded.clientFormInputType.label}
              {clientFormField.mandatory && (
                <span
                  class={
                    theme && theme.requiredSign
                      ? theme.requiredSign
                      : styles.requiredSign
                  }
                >
                  *
                </span>
              )}
            </label>
          </div>
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "DATE"
    ) {
      return (
        <div
          key={clientFormField.id}
          class={
            theme && theme.inputField ? theme.inputField : styles.inputField
          }
        >
          <label
            htmlFor={clientFormField.id}
            class={theme && theme.label ? theme.label : styles.label}
          >
            {clientFormField._embedded.clientFormInputType.label}
            {clientFormField.mandatory && (
              <span
                class={
                  theme && theme.requiredSign
                    ? theme.requiredSign
                    : styles.requiredSign
                }
              >
                *
              </span>
            )}
          </label>
          <input
            name={clientFormField._embedded.clientFormInputType.label}
            id={clientFormField.id}
            type="date"
            placeholder={clientFormField._embedded.clientFormInputType.label}
            onChange={this.onInputChange}
            onBlur={this.onInputBlur}
            class={styles.input}
            lang={locale}
            value={value}
          />
          {error && <InputError error={error} locale={locale} />}
        </div>
      );
    } else if (
      clientFormField._embedded.clientFormInputType.inputType === "ADDRESS"
    ) {
      let parsedValue;
        try {
          parsedValue = value ? JSON.parse(value) : undefined;
        } catch {
          parsedValue = undefined;
        }
      return (
        <AutocompleteAddress
          key={clientFormField.id}
          googleMapURL={GOOGLE_MAP_URL}
          loadingElement={<div style={{ height: `100%` }} />}
          value={parsedValue}
          clientFormField={clientFormField}
          onAddressChange={this.onAddressChange}
          onAddressBlur={this.onAddressBlur}
          isClientInformationMandatory={isClientInformationMandatory}
          error={error}
          locale={locale}
        />
      );
    }
  }
}
